module.exports = __webpack_public_path__ + "static/img/kham-pha-3.2deb9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kham-pha-3.png
// module id = 6O2E
// module chunks = 1